import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "../helpers/click_outside_mixin"

export default class extends Controller {
  static targets = [ "trigger" ]

  connect() {
    this._clickOutside = useClickOutside(this.element, () => {
      this.element.classList.remove("is-active")
      this._clickOutside.remove()
      this._setExpanded(false)
    })
  }

  disconnect() {
    this._clickOutside?.remove()
  }

  toggle(event) {
    event.preventDefault()
    const open = !this.element.classList.contains("is-active")
    this.setOpen(open)
  }

  setOpen(open) {
    this.element.classList.toggle("is-active", open)
    this._setExpanded(open)
    if (open) {
      this._clickOutside.add()
    } else {
      this._clickOutside.remove()
    }
  }

  _setExpanded(open) {
    if (!this.hasTriggerTarget) return
    this.triggerTarget.setAttribute("aria-expanded", open ? "true" : "false")
  }
}
